import React from "react";

import DivyAILogo from "assets/images/divyai-logo.svg";
import { useTranslation } from "i18n";

import "./style.css";

export const DIVYAI_URL = "https://divyai.com";

const PoweredByDivyAI = ({ variant = "footer" }) => {
  const { t } = useTranslation();
  const isPartner = variant === "header";

  return (
    <a
      className={`powered-by-divyai powered-by-divyai--${variant}`}
      href={DIVYAI_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t(isPartner ? "footer.inPartnershipAria" : "footer.poweredByAria")}
      title={t(isPartner ? "footer.inPartnershipAria" : "footer.poweredByAria")}
    >
      <span className="powered-by-divyai__label">
        {t(isPartner ? "footer.inPartnership" : "footer.poweredBy")}
      </span>
      <img
        className="powered-by-divyai__logo"
        src={DivyAILogo}
        alt="DivyAI LLC"
      />
    </a>
  );
};

export default PoweredByDivyAI;
